import AuthRoutes from './auth.routes';
import AdminRoutes from './admin.routes';
import { useSession } from 'context/SessionContext';

type Rules = "admin" | "auth";
type RoutesByRules = {
  [key in Rules]: JSX.Element
}
const routesByRules: RoutesByRules = {
  "admin": <AdminRoutes />,
  "auth": <AuthRoutes />
}


const Routes = () => {
  const { signed } = useSession();
  const userRule: Rules = 'admin';

  if (!signed)
    return routesByRules['auth'];

  return routesByRules[userRule];
}

export default Routes;